module.exports = __webpack_public_path__ + "img/91c3a2c.jpg";